import { useLocation, Outlet } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
// @mui
import { Box } from '@mui/material';
//
import { SellerPublicPageHeader } from './EndUserHeader';
import SellerPageFooter from './SellerPageFooter';
import ThemeUpdater from '../../components/minimal/ThemeUpdater';
import { useSellerPageContext } from '../../context-state/SellerPageContext';
import { IFrameView } from '../../pages/common/event/IFrameView';
import { isEmbedMode } from '../../utils/iframe';
import { FaviconHandler } from '../../components/FaviconHandler'
import { PwaHandler } from '../../components/PwaHandler'
// ----------------------------------------------------------------------

export default function MainLayout() {
    const { pathname } = useLocation();
    const { accountContext } = useSellerPageContext();
    const { account } = accountContext;

    const isHome = pathname === '/';

    // Use useMemo to calculate embed mode once and cache it
    // This prevents the flicker by ensuring consistent value across renders
    const isEmbed = useMemo(() => {
        // Check immediately on first render
        return isEmbedMode();
    }, []); // Empty dependency array means this only runs once

    const hideHeader = isEmbed;
    const hideFooter = isEmbed;
    const sellerIcon = account?.design?.profileImageIsLogo && account?.design?.profileImage ? account?.design?.profileImage : null

    return (
        <IFrameView>
            {sellerIcon && <FaviconHandler icon={sellerIcon} />}
            {sellerIcon && <PwaHandler icon={sellerIcon} handler={account?.handler} />}
            <ThemeUpdater
                primaryColor={account?.design?.sellerPagePrimaryColor}
                fontFamily={account?.design?.sellerPageFont}
                fontUrl={account?.design?.sellerPageFontUrl}
                titleFontFamily={account?.design?.sellerPageTitleFont}
                titleFontUrl={account?.design?.sellerPageTitleFontUrl}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            ...(!isHome && {
                                pt: { xs: 8, md: 11 },
                            }),
                        }}
                    >
                        {!hideHeader && <SellerPublicPageHeader />}
                        <Box minHeight="50vh">
                            <Outlet />
                        </Box>
                        {!hideFooter && <SellerPageFooter />}
                    </Box>
                </Box>
            </ThemeUpdater>
        </IFrameView>
    );
}
